import noteViolet from "@/assets/note-violet.jpg?format=webp&quality=72";
import noteClove from "@/assets/note-clove.jpg?format=webp&quality=72";
import noteStarAnise from "@/assets/note-star-anise.jpg?format=webp&quality=72";
import noteCedarwood from "@/assets/note-cedarwood.jpg?format=webp&quality=72";
import noteVetiver from "@/assets/note-vetiver.jpg?format=webp&quality=72";
import noteRose from "@/assets/note-rose.jpg?format=webp&quality=72";
import noteLabdanum from "@/assets/note-labdanum.jpg?format=webp&quality=72";
import noteAmber from "@/assets/note-amber.jpg?format=webp&quality=72";
import noteBlackTea from "@/assets/note-black-tea.jpg?format=webp&quality=72";
import noteCardamom from "@/assets/note-cardamon.jpg?format=webp&quality=72";
import noteFrankincense from "@/assets/note-frankincense.jpg?format=webp&quality=72";
import noteGuaiacwood from "@/assets/note-guaiacwood.jpg?format=webp&quality=72";
import noteHay from "@/assets/note-hay.jpg?format=webp&quality=72";
import noteHoWood from "@/assets/note-ho-wood.jpg?format=webp&quality=72";
import noteHoney from "@/assets/note-honey.jpg?format=webp&quality=72";
import noteJuniperBerry from "@/assets/note-juniper-berry.jpg?format=webp&quality=72";
import noteLavender from "@/assets/note-lavender.jpg?format=webp&quality=72";
import noteLemon from "@/assets/note-lemon.jpg?format=webp&quality=72";
import noteMarshmallow from "@/assets/note-marshmallow.jpg?format=webp&quality=72";
import noteMastic from "@/assets/note-mastic.jpg?format=webp&quality=72";
import noteMyrrh from "@/assets/note-myrrh.jpg?format=webp&quality=72";
import noteOakmoss from "@/assets/note-oakmoss.jpg?format=webp&quality=72";
import noteOakwood from "@/assets/note-oakwood.jpg?format=webp&quality=72";
import notePalmarosa from "@/assets/note-palmarosa.jpg?format=webp&quality=72";
import notePatchouli from "@/assets/note-patchouli.jpg?format=webp&quality=72";
import notePinkPepper from "@/assets/note-pink-pepper.jpg?format=webp&quality=72";
import noteRosemary from "@/assets/note-rosemary.jpg?format=webp&quality=72";
import noteSandalwood from "@/assets/note-sandalwood.jpg?format=webp&quality=72";
import noteSweetFennel from "@/assets/note-sweet-fennel.jpg?format=webp&quality=72";
import noteTonkaBean from "@/assets/note-tonka-bean.jpg?format=webp&quality=72";
import noteTuberose from "@/assets/note-tuberose.jpg?format=webp&quality=72";
import noteVanilla from "@/assets/note-vanilla.jpg?format=webp&quality=72";
import productArchivist from "@/assets/product-archivist.jpg?format=webp&quality=72";
import productGentleMadness from "@/assets/product-gentle-madness.jpg?format=webp&quality=72";
import productStill from "@/assets/product-still.jpg?format=webp&quality=72";
import productVelvetSugar from "@/assets/product-velvet-sugar.jpg?format=webp&quality=72";
import bottleArchivistCap from "@/assets/bottle-archivist-cap.jpg?format=webp&quality=72";
import bottleArchivistSpray from "@/assets/bottle-archivist-spray.jpg?format=webp&quality=72";
import bottleGentleMadnessCap from "@/assets/bottle-gentle-madness-cap.jpg?format=webp&quality=72";
import bottleGentleMadnessSpray from "@/assets/bottle-gentle-madness-spray.jpg?format=webp&quality=72";
import bottleHiddenCap from "@/assets/bottle-hidden-cap.jpg?format=webp&quality=72";
import bottleHiddenSpray from "@/assets/bottle-hidden-spray.jpg?format=webp&quality=72";
import productHidden from "@/assets/product-hidden.jpg?format=webp&quality=72";
import hiddenGreenVelvet from "@/assets/hidden-green-velvet.png.asset.json";
import hiddenInHand from "@/assets/hidden-in-hand.png.asset.json";

import bottleStillCap from "@/assets/bottle-still-cap.jpg?format=webp&quality=72";
import bottleStillSpray from "@/assets/bottle-still-spray.jpg?format=webp&quality=72";
import bottleVelvetSugarCap from "@/assets/bottle-velvet-sugar-cap.jpg?format=webp&quality=72";
import bottleVelvetSugarSpray from "@/assets/bottle-velvet-sugar-spray.jpg?format=webp&quality=72";

export type Character = {
  slug: string;
  name: string;
  epithet: string;
  tagline: string;
  image: string;
  paragraphs: string[];
  role: string;
  smellsLike: string;
  usedIn: string[];
  pairsWith: string;
  cardBlurb: string;
};

export const characters: Character[] = [
  {
    slug: "violet-the-ghost-in-the-garden",
    name: "Violet",
    epithet: "The Ghost in the Garden",
    tagline: "A trace of silk gloves and green memory, vanishing as you reach for it.",
    image: noteViolet,
    cardBlurb: "A trace of silk gloves and green memory, vanishing as you reach for it.",
    paragraphs: [
      "Violet is not one thing, but a specter made of many — a blend of leaf, petal, and the imagined scent of memory itself. You smell her in old letters, in chilled spring air, in the powder of a hand long withdrawn. She is elusive by nature; in perfumery, true violet blossom cannot be extracted, so perfumers build her from shadows: ionones, violet leaf, orris root, and soft woods.",
      "She plays a heart note role with top note volatility — rising early, lingering strangely, then fading like a forgotten name.",
    ],
    role: "Heart-leaning top note",
    smellsLike: "Powder, cool earth, crushed leaves, melancholic sweetness",
    usedIn: ["Hidden", "Velvet Sugar"],
    pairsWith: "Ambrette, sandalwood, tonka, cedarwood, oakmoss",
  },
  {
    slug: "clove-the-spiced-bloom",
    name: "Clove",
    epithet: "The Spiced Bloom",
    tagline: "A bud that holds both sweetness and fire. A spice woven through centuries.",
    image: noteClove,
    cardBlurb: "A bud that holds both sweetness and fire. A spice woven through centuries.",
    paragraphs: [
      "Clove is a flower caught mid-breath — an unopened bud, dried to a dark ember and carrying within it the whole memory of warmth. She is the spice of cathedrals and apothecaries, of mulled wine and embalming oil; sweetness and antiseptic bite held in a single small body.",
      "In a composition she works as a fierce, radiant heart — eugenol-rich and persistent, lending carnation-like depth and a slow medicinal glow that keeps a fragrance from ever going quiet.",
    ],
    role: "Spiced heart note",
    smellsLike: "Hot carnation, dried wood, sweet smoke, medicinal warmth",
    usedIn: ["Hidden"],
    pairsWith: "Rose, vanilla, sandalwood, labdanum, star anise",
  },
  {
    slug: "star-anise-the-celestial-seed",
    name: "Star Anise",
    epithet: "The Celestial Seed",
    tagline: "Star Anise is a small fallen constellation, fragrant with licorice, shadow, and old medicine.",
    image: noteStarAnise,
    cardBlurb: "Star Anise is a small fallen constellation, fragrant with licorice, shadow, and old medicine.",
    paragraphs: [
      "Star Anise wears its geometry like a sigil — eight woody chambers arranged in perfect symmetry, each cradling a seed. Cool and sweet, with the clean lift of licorice and a faintly resinous bite, she gives a fragrance its first sharp intake of breath.",
      "Volatile and luminous, she belongs to the opening — a top-note flash of anethole that sparkles for a moment before dissolving into the warmer notes beneath, leaving the impression of light moving through dark glass.",
    ],
    role: "Sparkling top note",
    smellsLike: "Licorice, cool spice, sweet wood, aniseed brightness",
    usedIn: ["Hidden"],
    pairsWith: "Violet, clove, fir, bergamot, vetiver",
  },
  {
    slug: "cedarwood-the-quiet-architect",
    name: "Cedarwood",
    epithet: "The Quiet Architect",
    tagline: "A dry spine of wood and air, shaping space without fanfare.",
    image: noteCedarwood,
    cardBlurb: "A dry spine of wood and air, shaping space without fanfare.",
    paragraphs: [
      "Cedarwood is structure made scent — the dry, pencil-shaving clarity of a wood that asks for nothing and holds everything together. She is the beam beneath the floor, the frame around the picture, the architecture you never notice until it is gone.",
      "As a base note she lends spine and longevity, a grainy, almost mineral dryness that grounds brighter accords and gives a fragrance its quiet sense of permanence.",
    ],
    role: "Dry base note",
    smellsLike: "Pencil shavings, dry timber, clean resin, cool air",
    usedIn: ["Hidden"],
    pairsWith: "Vetiver, patchouli, violet, orris, oakmoss",
  },
  {
    slug: "vetiver-the-root-of-shadows",
    name: "Vetiver",
    epithet: "The Root of Shadows",
    tagline: "Earth pulled up by its roots — smoke, soil and cool green shade.",
    image: noteVetiver,
    cardBlurb: "Earth pulled up by its roots — smoke, soil and cool green shade.",
    paragraphs: [
      "Vetiver is the underside of the world — a tangle of roots drawn up from the dark, carrying soil, smoke, and the cool green memory of rain. Earthy and bittersweet, she is at once grounding and strange, the smell of a place rather than a thing.",
      "A tenacious base note, she anchors a composition with damp, rooty depth and a faint smokiness, holding the lighter notes to the skin long after they would otherwise have vanished.",
    ],
    role: "Earthy base note",
    smellsLike: "Damp soil, smoke, cut grass, bitter root",
    usedIn: ["Hidden"],
    pairsWith: "Cedarwood, patchouli, violet, oakmoss, star anise",
  },
  {
    slug: "rose-the-sovereign-bloom",
    name: "Rose",
    epithet: "The Sovereign Bloom",
    tagline: "Soft as prayer, sharp as thorns. The first symbol, and the last.",
    image: noteRose,
    cardBlurb: "Soft as prayer, sharp as thorns. The first symbol, and the last.",
    paragraphs: [
      "There is no escaping Rose. She is monarchy and martyr, wound and remedy, sacred oil and dangerous gift. No other flower carries such contradiction — honeyed and green, spiced and metallic, velvet and blood. In perfumery, she is not one thing, but a pantheon: Bulgarian and Turkish absolutes, Moroccan concretes, distilled petals, or CO₂ extractions — each telling a different chapter of the same myth.",
      "She governs the heart note, opening in light and unfolding toward shadow. Always central, always watching.",
    ],
    role: "Heart note",
    smellsLike: "Petal, fruit, metal, green, spice, honey, grief",
    usedIn: ["Velvet Sugar"],
    pairsWith: "Frankincense, myrrh, patchouli, ambrette, ginger, tonka",
  },
  {
    slug: "labdanum-the-golden-shadow",
    name: "Labdanum",
    epithet: "The Golden Shadow",
    tagline: "Ambers true face; wild, resinous, and draped in leathered light.",
    image: noteLabdanum,
    cardBlurb: "Ambers true face; wild, resinous, and draped in leathered light.",
    paragraphs: [
      "Once scraped from the beards of goats wandering among rockrose shrubs, Labdanum is no tidy concept — it is the tangled, animalic root of every amber myth. Where synthetics mimic warmth, Labdanum radiates with centuries of sun, fur, incense, and devotion. Sweet, leathery, with the ghost of dried fruit and saltwind tar, it anchors perfumes in the realm of memory and myth.",
      "In perfumery, Labdanum is a base note — dense and slow to speak, but when it does, it carries the weight of ritual and ruin. It lives in shadows but gives them gold.",
    ],
    role: "Base note, fixative",
    smellsLike: "Soft leather, dried resin, incense wax, antique amber",
    usedIn: ["Velvet Sugar"],
    pairsWith: "Vanilla, frankincense, patchouli, oakwood, benzoin",
  },
  {
    slug: "amber-the-fossil-glow",
    name: "Amber",
    epithet: "The Fossil Glow",
    tagline: "Sunlight pressed into resin, slow and golden as memory.",
    image: noteAmber,
    cardBlurb: "Sunlight pressed into resin, slow and golden as memory.",
    paragraphs: [
      "Amber is not a single material but an accord — a warm conspiracy of labdanum, benzoin, vanilla and balsams that conjures the impression of fossilised light. She is the smell of sun-warmed skin against old velvet, of resin held in the hand until it softens.",
      "As a base note she radiates slow heat, smoothing every edge above her into something honeyed, lived-in, and quietly luxurious.",
    ],
    role: "Warm base note",
    smellsLike: "Honeyed resin, soft powder, golden warmth, sun-warmed skin",
    usedIn: ["Velvet Sugar", "The Archivist"],
    pairsWith: "Labdanum, vanilla, tonka, sandalwood, frankincense",
  },
  {
    slug: "black-tea-the-steeped-hour",
    name: "Black Tea",
    epithet: "The Steeped Hour",
    tagline: "Dark leaves, dim light, and the bitter hush of a long afternoon.",
    image: noteBlackTea,
    cardBlurb: "Dark leaves, dim light, and the bitter hush of a long afternoon.",
    paragraphs: [
      "Black Tea is the scent of waiting — tannic, smoke-tinged, faintly floral. She holds the bitter glamour of an empty cup and the steam that rose from it an hour ago, the chamber slowly darkening around her.",
      "In composition she's a quiet heart note: dry, leafy, gently aromatic, lending an atmosphere of contemplation and worn upholstery to whatever surrounds her.",
    ],
    role: "Aromatic heart note",
    smellsLike: "Dry leaves, tannin, faint smoke, antique paper",
    usedIn: ["Velvet Sugar", "The Archivist"],
    pairsWith: "Rose, amber, oakwood, vanilla, tonka",
  },
  {
    slug: "cardamom-the-green-ember",
    name: "Cardamom",
    epithet: "The Green Ember",
    tagline: "A spice that hides cool breath inside its fire.",
    image: noteCardamom,
    cardBlurb: "A spice that hides cool breath inside its fire.",
    paragraphs: [
      "Cardamom is the rare spice that opens cool — eucalyptic, almost camphorous — before revealing a warm, peppery heart. She has the green snap of a freshly cracked pod and the slow, resinous sweetness that follows.",
      "A versatile top-to-heart note, she lifts compositions without burning them, lending elegance and a strange luminous chill.",
    ],
    role: "Spiced top note",
    smellsLike: "Cool spice, green camphor, sweet pepper, dry resin",
    usedIn: [],
    pairsWith: "Rose, sandalwood, vanilla, lemon, tonka",
  },
  {
    slug: "frankincense-the-listening-smoke",
    name: "Frankincense",
    epithet: "The Listening Smoke",
    tagline: "Resin tears burned slow, lifting the room toward something older.",
    image: noteFrankincense,
    cardBlurb: "Resin tears burned slow, lifting the room toward something older.",
    paragraphs: [
      "Frankincense is the smell of attention — pale resin tears warmed until they sigh out a smoke that is at once citric, piney, and devotional. She has carried prayer for five thousand years and still smells like the moment a thought leaves the body.",
      "She works as a luminous heart-into-base, lending cool height and a sacred dryness that holds every sweeter note in suspension above the skin.",
    ],
    role: "Resinous heart note",
    smellsLike: "Cool incense, pine resin, citrus peel, sacred smoke",
    usedIn: [],
    pairsWith: "Myrrh, rose, labdanum, oakmoss, sandalwood",
  },
  {
    slug: "guaiacwood-the-smoked-cathedral",
    name: "Guaiacwood",
    epithet: "The Smoked Cathedral",
    tagline: "Old wood warmed by fire, rose-tinged and slow to leave.",
    image: noteGuaiacwood,
    cardBlurb: "Old wood warmed by fire, rose-tinged and slow to leave.",
    paragraphs: [
      "Guaiacwood is the rarest kind of wood note — softly smoked, faintly rose-tinted, with a creamy almost tarry undertow. She smells like the inside of a beam after decades of woodsmoke and prayer.",
      "A dense base note, she lends a violet-leather warmth that makes florals deeper and gourmands stranger.",
    ],
    role: "Smoky base note",
    smellsLike: "Soft smoke, dry rose, warm tar, polished wood",
    usedIn: ["Velvet Sugar"],
    pairsWith: "Rose, violet, labdanum, vanilla, tonka",
  },
  {
    slug: "hay-the-summer-keeping",
    name: "Hay",
    epithet: "The Summer Keeping",
    tagline: "Cut grass dried in a loft, sweetened by time and dust.",
    image: noteHay,
    cardBlurb: "Cut grass dried in a loft, sweetened by time and dust.",
    paragraphs: [
      "Hay is the smell of stored summer — coumarin-warm, faintly tobacco-ish, with the dry hush of stalks that have spent a season in the dark. She is nostalgia in note form: barn rafters, sun on cloth, the powder of long afternoons.",
      "She drifts through the base of a fragrance as a soft, almond-tinged warmth that smudges every harder edge into something pastoral.",
    ],
    role: "Sweet base note",
    smellsLike: "Dried grass, coumarin, tobacco, warm dust",
    usedIn: ["Hidden"],
    pairsWith: "Tonka, vanilla, lavender, oakmoss, vetiver",
  },
  {
    slug: "ho-wood-the-pale-breath",
    name: "Ho Wood",
    epithet: "The Pale Breath",
    tagline: "Cool linalool light, like camphor seen through gauze.",
    image: noteHoWood,
    cardBlurb: "Cool linalool light, like camphor seen through gauze.",
    paragraphs: [
      "Ho Wood is the gentler cousin of rosewood — high in linalool, soft and almost watery, with a clean wooden coolness that feels more like air than timber. She is breath rather than substance.",
      "A translucent heart note, she lends compositions an airy spaciousness, the sensation of a window being cracked open in a closed room.",
    ],
    role: "Airy heart note",
    smellsLike: "Cool wood, soft camphor, clean linalool, pale floral",
    usedIn: [],
    pairsWith: "Lavender, rosemary, juniper, sandalwood, mastic",
  },
  {
    slug: "honey-the-slow-gold",
    name: "Honey",
    epithet: "The Slow Gold",
    tagline: "Sweetness with a body, half flower and half animal.",
    image: noteHoney,
    cardBlurb: "Sweetness with a body, half flower and half animal.",
    paragraphs: [
      "Honey is sweetness that remembers the hive — waxen, faintly animalic, with a warm floral hum beneath the gold. She is never innocent; there is always something thick and faintly feral in her, the trace of bees on the skin.",
      "Used sparingly she is a heart-base bridge, lending erotic warmth and the slow drag of nectar to florals and ambers alike.",
    ],
    role: "Animalic heart note",
    smellsLike: "Beeswax, nectar, warm skin, floral musk",
    usedIn: [],
    pairsWith: "Rose, tuberose, tobacco, labdanum, vanilla",
  },
  {
    slug: "juniper-berry-the-cold-blue",
    name: "Juniper Berry",
    epithet: "The Cold Blue",
    tagline: "A small dark berry breathing pine and gin into the air.",
    image: noteJuniperBerry,
    cardBlurb: "A small dark berry breathing pine and gin into the air.",
    paragraphs: [
      "Juniper Berry is a winter creature — resinous, slightly turpenic, with the cool blue lift of pine needles broken between fingers. She smells of gin, of churchyards, of weather pressing in at a window.",
      "A bright top note, she clears the palate of a fragrance with a single cold breath before yielding to whatever warmth is built underneath.",
    ],
    role: "Bright top note",
    smellsLike: "Pine resin, gin, cold air, crushed berries",
    usedIn: [],
    pairsWith: "Rosemary, lavender, vetiver, mastic, frankincense",
  },
  {
    slug: "lavender-the-old-witness",
    name: "Lavender",
    epithet: "The Old Witness",
    tagline: "Linen drawers, herbal mountains, and the calm of being kept.",
    image: noteLavender,
    cardBlurb: "Linen drawers, herbal mountains, and the calm of being kept.",
    paragraphs: [
      "Lavender is the herb of every grandmother and every priest — clean, slightly camphorous, with a soft floral underside that smells of pressed sheets and convalescence. She has been in the room longer than anyone.",
      "She works the top and heart, a luminous aromatic that calms compositions while keeping them awake.",
    ],
    role: "Aromatic top note",
    smellsLike: "Herbal flower, soft camphor, dried linen, blue air",
    usedIn: [],
    pairsWith: "Tonka, hay, vetiver, rosemary, oakmoss",
  },
  {
    slug: "lemon-the-quick-blade",
    name: "Lemon",
    epithet: "The Quick Blade",
    tagline: "A bright cut of citrus that opens the door and disappears.",
    image: noteLemon,
    cardBlurb: "A bright cut of citrus that opens the door and disappears.",
    paragraphs: [
      "Lemon is a flash — peel-bright, almost metallic, with the green snap of a knife slipping under rind. She arrives loud and leaves fast, leaving the air sharper than she found it.",
      "A volatile top note, she is the first impression of a perfume: clarity, brightness, the cold sparkle of an opening line.",
    ],
    role: "Sparkling top note",
    smellsLike: "Fresh peel, cold citrus, green zest, clean acid",
    usedIn: [],
    pairsWith: "Cardamom, rosemary, lavender, ho wood, frankincense",
  },
  {
    slug: "marshmallow-the-soft-trick",
    name: "Marshmallow",
    epithet: "The Soft Trick",
    tagline: "A confection note that smells like something half-remembered.",
    image: noteMarshmallow,
    cardBlurb: "A confection note that smells like something half-remembered.",
    paragraphs: [
      "Marshmallow is an illusion — a cloud of vanillic, almondy, faintly orris-cool sweetness built to evoke a pillowed confection that never quite existed. She is texture as much as scent: soft, white, slightly powdered.",
      "A gourmand heart note, she plushens florals and tames spices, turning sweetness into atmosphere rather than sugar.",
    ],
    role: "Gourmand heart note",
    smellsLike: "Soft sugar, almond, vanilla cloud, cool powder",
    usedIn: ["Velvet Sugar", "A Gentle Madness"],
    pairsWith: "Violet, rose, tonka, vanilla, sandalwood",
  },
  {
    slug: "mastic-the-pale-resin",
    name: "Mastic",
    epithet: "The Pale Resin",
    tagline: "A Mediterranean tear that smells of pine, salt and clean stone.",
    image: noteMastic,
    cardBlurb: "A Mediterranean tear that smells of pine, salt and clean stone.",
    paragraphs: [
      "Mastic is the resin of a sun-bitten island shrub — pale, almost chewy, with a piney, faintly camphorous transparency. She is the smell of a coast that has been hot for centuries.",
      "As a heart note she gives a fragrance a clean, vegetal greenness that feels both ancient and just rinsed.",
    ],
    role: "Resinous heart note",
    smellsLike: "Pale pine, sea salt, clean stone, faint camphor",
    usedIn: ["The Still"],
    pairsWith: "Juniper, rosemary, ho wood, frankincense, vetiver",
  },
  {
    slug: "myrrh-the-bitter-balm",
    name: "Myrrh",
    epithet: "The Bitter Balm",
    tagline: "A resin that smells of medicine, mourning, and warm shadow.",
    image: noteMyrrh,
    cardBlurb: "A resin that smells of medicine, mourning, and warm shadow.",
    paragraphs: [
      "Myrrh is frankincense's darker sibling — earthier, more bitter, with a leathery, mushroomy underside and a slow medicinal warmth. She is the smell of a wound being dressed in a cathedral.",
      "A heavy base note, she lends gravity and a faintly funereal sweetness, deepening every resin and rose she meets.",
    ],
    role: "Resinous base note",
    smellsLike: "Bitter resin, warm leather, dry earth, sacred balm",
    usedIn: [],
    pairsWith: "Frankincense, labdanum, rose, oakwood, patchouli",
  },
  {
    slug: "oakmoss-the-forest-floor",
    name: "Oakmoss",
    epithet: "The Forest Floor",
    tagline: "Damp green velvet, ink-dark and quietly ancient.",
    image: noteOakmoss,
    cardBlurb: "Damp green velvet, ink-dark and quietly ancient.",
    paragraphs: [
      "Oakmoss is the lichen scraped from the bark of old trees, dried and tinctured into something that smells like a whole forest after rain — inky, slightly leathery, with the dark mineral hush of wet stone and bark.",
      "A foundational base note in classical chypres and fougères, she anchors a composition with a damp, shadowed greenness that nothing synthetic has ever fully replicated.",
    ],
    role: "Earthy base note",
    smellsLike: "Wet bark, ink, damp leaves, mineral shadow",
    usedIn: ["Hidden"],
    pairsWith: "Vetiver, patchouli, labdanum, hay, lavender",
  },
  {
    slug: "oakwood-the-slow-cask",
    name: "Oakwood",
    epithet: "The Slow Cask",
    tagline: "Charred barrel staves and the warm hush of cellar dark.",
    image: noteOakwood,
    cardBlurb: "Charred barrel staves and the warm hush of cellar dark.",
    paragraphs: [
      "Oakwood is the smell of patience — staves charred on the inside, steeped for years in wine and spirit until they give back vanilla, smoke, and a slow tannic sweetness. She is a barrel remembered as scent.",
      "A dense base note, she carries woody depth tinged with caramel and char, anchoring richer compositions in cellar warmth.",
    ],
    role: "Smoky base note",
    smellsLike: "Charred barrel, faint vanilla, dry tannin, cellar warmth",
    usedIn: ["The Archivist"],
    pairsWith: "Vanilla, tonka, black tea, labdanum, amber",
  },
  {
    slug: "palmarosa-the-rose-grass",
    name: "Palmarosa",
    epithet: "The Rose Grass",
    tagline: "A green stem that opens, against all reason, into rose.",
    image: notePalmarosa,
    cardBlurb: "A green stem that opens, against all reason, into rose.",
    paragraphs: [
      "Palmarosa is a wild Indian grass that, when distilled, produces an oil so rich in geraniol it smells uncannily of rose — green, lemony, soft-skinned, and a touch wild. She is rose without the velvet, rose loosened back into a field.",
      "She works the heart, lending a clean floral sweetness that makes fuller roses feel airier and lighter.",
    ],
    role: "Floral heart note",
    smellsLike: "Green rose, lemon stem, soft geranium, warm grass",
    usedIn: [],
    pairsWith: "Rose, sandalwood, vetiver, ho wood, tonka",
  },
  {
    slug: "patchouli-the-second-skin",
    name: "Patchouli",
    epithet: "The Second Skin",
    tagline: "Ink-dark earth that the body learns to wear like a cloak.",
    image: notePatchouli,
    cardBlurb: "Ink-dark earth that the body learns to wear like a cloak.",
    paragraphs: [
      "Patchouli is the most divisive of the great base notes — earthy, camphorous, faintly chocolatey, with a damp basement undertone that some read as dirt and others as sex. Aged, she becomes wine-dark and almost edible.",
      "A tenacious base note, she gives a perfume gravity and a slow, animal warmth; nothing else on earth roots a composition quite like her.",
    ],
    role: "Earthy base note",
    smellsLike: "Damp earth, ink, dark cocoa, dry leaves",
    usedIn: ["Hidden"],
    pairsWith: "Rose, labdanum, vetiver, oakmoss, amber",
  },
  {
    slug: "pink-pepper-the-bright-bite",
    name: "Pink Pepper",
    epithet: "The Bright Bite",
    tagline: "A coral berry that fizzes against the tongue of the air.",
    image: notePinkPepper,
    cardBlurb: "A coral berry that fizzes against the tongue of the air.",
    paragraphs: [
      "Pink Pepper is not pepper at all but the bright dried berry of the Schinus tree — rosy, faintly fruity, with a sparkling peppery snap that crackles on the way in. She is fizz and flicker, a fragrance's first laugh.",
      "A radiant top note, she sharpens florals and brightens gourmands without ever turning hot.",
    ],
    role: "Sparkling top note",
    smellsLike: "Rosy pepper, dried berry, sparkling spice, light citrus",
    usedIn: ["Velvet Sugar"],
    pairsWith: "Rose, violet, marshmallow, cardamom, amber",
  },
  {
    slug: "rosemary-the-cold-altar",
    name: "Rosemary",
    epithet: "The Cold Altar",
    tagline: "An herb of remembrance, sharp with stone and smoke.",
    image: noteRosemary,
    cardBlurb: "An herb of remembrance, sharp with stone and smoke.",
    paragraphs: [
      "Rosemary is the herb of memory — pungent, camphorous, almost mineral, with a green smokiness that rises like incense from a sunlit hillside. She is funeral and feast at once.",
      "A bracing top-to-heart aromatic, she gives fougères their spine and any composition a clean, ritual edge.",
    ],
    role: "Aromatic top note",
    smellsLike: "Green camphor, dry pine, warm stone, herbal smoke",
    usedIn: ["Hidden", "The Still"],
    pairsWith: "Lavender, juniper, mastic, oakmoss, frankincense",
  },
  {
    slug: "sandalwood-the-warm-prayer",
    name: "Sandalwood",
    epithet: "The Warm Prayer",
    tagline: "Creamy heartwood that smells of skin and old devotion.",
    image: noteSandalwood,
    cardBlurb: "Creamy heartwood that smells of skin and old devotion.",
    paragraphs: [
      "Sandalwood is the rarest of warm woods — soft, lactic, almost milky, with a quiet sacred sweetness that lingers like the inside of a temple. True Mysore is now almost myth; her modern incarnations are gentler but still carry the warmth of the original.",
      "A foundational base note, she gives a fragrance a slow creamy radiance and the closeness of skin warmed under cloth.",
    ],
    role: "Creamy base note",
    smellsLike: "Warm milk, soft wood, sacred resin, dry powder",
    usedIn: [],
    pairsWith: "Rose, vanilla, amber, ho wood, cardamom",
  },
  {
    slug: "sweet-fennel-the-licorice-light",
    name: "Sweet Fennel",
    epithet: "The Licorice Light",
    tagline: "Cool anise feathered with green, brighter than its shadow.",
    image: noteSweetFennel,
    cardBlurb: "Cool anise feathered with green, brighter than its shadow.",
    paragraphs: [
      "Sweet Fennel is anise's lighter sister — green, slightly grassy, with a cool licorice lift that feels almost minty. She is the herb of digestifs and seedy little candies kept in a tin.",
      "A bright top note, she opens a composition with a curious sweetness that reads as both fresh and faintly nostalgic.",
    ],
    role: "Aromatic top note",
    smellsLike: "Cool licorice, green seed, soft sugar, herbal lift",
    usedIn: ["A Gentle Madness"],
    pairsWith: "Star anise, lavender, marshmallow, violet, tonka",
  },
  {
    slug: "tonka-bean-the-soft-coumarin",
    name: "Tonka Bean",
    epithet: "The Soft Coumarin",
    tagline: "Almond, hay, and vanilla folded into a single warm bean.",
    image: noteTonkaBean,
    cardBlurb: "Almond, hay, and vanilla folded into a single warm bean.",
    paragraphs: [
      "Tonka Bean is a small black seed from South America whose dried, coumarin-rich fragrance smells of vanilla, almond, hay, and faint tobacco at once. She is the warm familiar at the bottom of countless great perfumes.",
      "A plush base note, she rounds a composition with a soft, slightly bittersweet glow that reads as comfort itself.",
    ],
    role: "Sweet base note",
    smellsLike: "Vanilla, almond, dried hay, soft tobacco",
    usedIn: ["Hidden", "The Archivist", "A Gentle Madness"],
    pairsWith: "Vanilla, hay, lavender, amber, sandalwood",
  },
  {
    slug: "tuberose-the-white-fever",
    name: "Tuberose",
    epithet: "The White Fever",
    tagline: "A flower that smells like skin, heat, and trouble.",
    image: noteTuberose,
    cardBlurb: "A flower that smells like skin, heat, and trouble.",
    paragraphs: [
      "Tuberose is the most carnal of the white florals — creamy, intoxicating, with a green stem-snap and an almost rubbery, mentholated underside. She has been considered dangerous for centuries, and not without reason.",
      "A commanding heart note, she fills a room with humid, narcotic sweetness; nothing else flowers quite so loudly.",
    ],
    role: "Floral heart note",
    smellsLike: "Creamy petal, warm skin, green stem, narcotic sweetness",
    usedIn: [],
    pairsWith: "Sandalwood, honey, vanilla, labdanum, ho wood",
  },
  {
    slug: "vanilla-the-quiet-hearth",
    name: "Vanilla",
    epithet: "The Quiet Hearth",
    tagline: "A pod of dark sweetness, smoky at the seam.",
    image: noteVanilla,
    cardBlurb: "A pod of dark sweetness, smoky at the seam.",
    paragraphs: [
      "Vanilla is a cured orchid pod — sweet, yes, but the real material is far stranger than the word suggests: leathery, smoky, faintly boozy, with a balsamic depth that has nothing to do with cupcakes. She is the slow dark gold at the bottom of a perfume.",
      "A foundational base note, she warms, sweetens, and lingers, lending every fragrance she touches a hush of skin and hearth.",
    ],
    role: "Sweet base note",
    smellsLike: "Cured pod, soft smoke, warm balsam, dark sugar",
    usedIn: ["The Archivist"],
    pairsWith: "Tonka, amber, sandalwood, oakwood, labdanum",
  },
];

export function getCharacter(slug: string) {
  return characters.find((c) => c.slug === slug);
}

export type ProductGalleryImage = {
  src: string;
  alt: string;
  caption: string;
};

export type Product = {
  slug: string;
  name: string;
  subtitle: string;
  price: string;
  installment: string;
  image: string;
  imageAlt: string;
  gallery: ProductGalleryImage[];
  /** Plain-language summary sentence for search engines and shoppers. Renders above the story copy. */
  searchAnchor?: string;
  storyTagline: string;
  noteLine: string;
  format: string;
  batch: string;
  accents: string[];
  storyParagraphs: string[];
  storyClose: string;
  buyNote?: string;
  size: string;
  ingredients: string;
  allergens: string;
  attributes: string;
  sku: string;
  noteSlugs: string[];
  shopifyHandle?: string;
};

export const products: Product[] = [
  {
    slug: "hidden",
    name: "Hidden",
    subtitle: "A Violet Fougère",
    price: "$135.00 USD",
    installment: "",
    image: productHidden,
    imageAlt:
      "Hidden 30 mL black glass perfume bottle by House of Apocrypha, gold and violet label, surrounded by violet flowers",
    gallery: [
      {
        src: hiddenGreenVelvet.url,
        alt: "Hidden bottle resting on deep green silk velvet",
        caption: "Bottle portrait · green velvet",
      },
      {
        src: hiddenInHand.url,
        alt: "Hidden bottle held in a hand, showing its scale and the gold-illustrated label",
        caption: "In hand · scale",
      },
      {
        src: bottleHiddenCap,
        alt: "Hidden bottle with black cap on emerald velvet with violets and fern",
        caption: "Bottle portrait · cap on",
      },
      {
        src: bottleHiddenSpray,
        alt: "Hidden bottle with silver atomizer exposed and a fine mist drifting across black velvet",
        caption: "Bottle study · silver atomizer in use",
      },
    ],
    searchAnchor:
      "Hidden is a small-batch natural eau de parfum from House of Apocrypha — a violet fougère of crushed violet leaf, star anise, clove, cedar, patchouli and vetiver in a 30 mL extrait.",
    storyTagline: "A sliver of green light in a darkened room.",
    noteLine: "Crushed violet · star anise · cedar shadow",
    format: "30ml extrait · $135",
    batch: "Batch I · limited release",
    accents: ["Crushed violets", "Star anise", "Clove", "Cedar", "Patchouli", "Vetiver", "Hay"],
    storyParagraphs: [
      "Hidden opens on a cool snap of crushed violet leaf and quick-silver bergamot — the clean edge of a straight razor catching dawn. Within minutes the flash dims, revealing a violet-iris veil shot through with dry spices: star anise, clove, and a wisp of rosemary smoke.",
      "As the bloom withdraws, the walls appear: grainy atlas-cedar boards, ink-black patchouli pages, and the dry root of Indonesian vetiver. Heliotrope and vanillin glow like motes of dust cutting through lamplight, while coumarin's hay-tonka warmth clings to skin like heat on freshly pressed wool.",
      "Hidden never shouts. It moves — green to violet, violet to shadowed wood — leaving only a trace: clean, mineral, quietly magnetic.",
    ],
    storyClose: "Wear it close. Wait. Let it disappear… and discover what remains.",
    size: "30 mL black glass bottle, presented in a black box.",
    ingredients:
      "Alcohol (cane sugar), parfum* (aromatic compounds from essential oils, CO₂ extracts, absolutes and purified plant isolates), aqua / water, Evernia prunastri extract (Oakmoss), Illicium verum fruit oil (Star Anise), Iris germanica root extract (Orris Root), Pogostemon cablin leaf oil (Patchouli), Vetiveria zizanioides root oil (Vetiver), triethyl citrate (natural ester of citric acid).",
    allergens:
      "*May contain naturally occurring fragrance allergens: limonene, linalool, geraniol, citronellol, citral, coumarin, eugenol, isoeugenol, farnesol, benzyl alcohol, benzyl benzoate, benzyl salicylate.",
    attributes:
      "Vegetarian • No phthalates • No parabens • No synthetic dyes • No formaldehyde.",
    sku: "HA-HIDDEN-30ML",
    noteSlugs: [
      "violet-the-ghost-in-the-garden",
      "star-anise-the-celestial-seed",
      "clove-the-spiced-bloom",
      "rosemary-the-cold-altar",
      "cedarwood-the-quiet-architect",
      "patchouli-the-second-skin",
      "vetiver-the-root-of-shadows",
      "oakmoss-the-forest-floor",
      "hay-the-summer-keeping",
      "tonka-bean-the-soft-coumarin",
    ],
  },
  {
    slug: "velvet-sugar",
    name: "Velvet Sugar",
    subtitle: "A Gourmand Floral",
    price: "$135.00 USD",
    installment: "",
    image: productVelvetSugar,
    imageAlt: "Velvet Sugar — confectionary floral still-life artwork for House of Apocrypha",
    gallery: [
      {
        src: bottleVelvetSugarCap,
        alt: "Velvet Sugar bottle with black cap among roses, velvet and candlelight",
        caption: "Bottle portrait · cap on",
      },
      {
        src: bottleVelvetSugarSpray,
        alt: "Velvet Sugar bottle with silver atomizer exposed, fragrance mist catching warm light",
        caption: "Bottle study · silver atomizer in use",
      },
    ],
    searchAnchor:
      "Velvet Sugar is a small-batch natural gourmand-floral perfume — candied violet, rose, pink pepper, marshmallow, black tea and amber resin in a 30 mL extrait by House of Apocrypha.",
    storyTagline: "A sweetness half-remembered in a shuttered room.",
    noteLine: "Candied violet · rose petal · amber resin",
    format: "30ml extrait · $135",
    batch: "Batch II · limited release",
    accents: [
      "Candied violets",
      "Pink pepper",
      "Rose petals",
      "Marshmallow",
      "Black tea",
      "Guaiacwood",
      "Amber resin",
    ],
    storyParagraphs: [
      "Velvet Sugar opens in a flicker of candied citrus and pink pepper, bright as sugared fruit catching candlelight. Soon the brightness softens into a plush floral haze — rose, violet, and pale blossoms drifting through velvet curtains.",
      "Then another sweetness appears: not dessert, but something older and stranger. Powdered confections, almond dust, sugared petals — the ghost of forgotten candies kept in a tin. Black tea darkens the heart. Orris cools it to a cosmetic hush. Woods and amber resin draw the sweetness downward into shadow.",
      "What lingers is not sugar, exactly, but atmosphere: candied petals, warm fabric, soft smoke, and skin.",
    ],
    storyClose: "Velvet Sugar moves from brightness to bloom, bloom to velvet dusk — decadent, secretive, quietly addictive. Sometimes it is old secrets that cast the longest shadows.",
    size: "30 mL black glass bottle, presented in a black box.",
    ingredients:
      "Alcohol (cane sugar), parfum* (aromatic compounds from essential oils, CO₂ extracts, absolutes and purified plant isolates), aqua / water, triethyl citrate (natural ester of citric acid).",
    allergens:
      "*May contain naturally occurring fragrance allergens: limonene, linalool, geraniol, citronellol, coumarin, benzyl alcohol, benzyl salicylate.",
    attributes:
      "Vegetarian • No phthalates • No parabens • No synthetic dyes • No formaldehyde.",
    sku: "HA-VELVET-30ML",
    noteSlugs: [
      "pink-pepper-the-bright-bite",
      "violet-the-ghost-in-the-garden",
      "rose-the-sovereign-bloom",
      "marshmallow-the-soft-trick",
      "black-tea-the-steeped-hour",
      "guaiacwood-the-smoked-cathedral",
      "amber-the-fossil-glow",
      "labdanum-the-golden-shadow",
    ],
  },
  {
    slug: "the-archivist",
    name: "The Archivist",
    subtitle: "Every library burns eventually. Some do so with intention.",
    price: "$135.00 USD",
    installment: "",
    image: productArchivist,
    imageAlt: "The Archivist — manuscript, quill and amber-glass still-life artwork for House of Apocrypha",
    gallery: [
      {
        src: bottleArchivistCap,
        alt: "The Archivist bottle with its distinctive brown wood cap among papers and lamp light",
        caption: "Bottle portrait · wood cap on",
      },
      {
        src: bottleArchivistSpray,
        alt: "The Archivist bottle with silver atomizer exposed, wood cap resting nearby, fragrance mist in warm study light",
        caption: "Bottle study · silver atomizer in use",
      },
    ],
    searchAnchor:
      "The Archivist is a small-batch natural perfume — wine-soaked oak, vanilla dust and scorched paper in a 30 mL extrait by House of Apocrypha.",
    storyTagline: "Dust, ink, and the warmth of a sealed drawer.",
    noteLine: "Wine-soaked oak · vanilla dust · scorched paper",
    format: "30ml extrait · $135",
    batch: "Batch I · limited release",
    accents: [
      "Wine-soaked oak",
      "Wild honey",
      "Aged amber",
      "Vanilla dust",
      "Steeped black tea",
      "Labdanum resin",
      "Tonka shadow",
      "Scorched paper",
    ],
    storyParagraphs: [
      "The Archivist lingers where paper has browned at the edges and rooms remember more than their occupants. It opens with the hush of old pages and dark tea, briefly illuminated by a thread of wild honey — warmth that feels poured rather than lit.",
      "Soon a richer structure appears: ambered resins, polished woods, and something deeper beneath them — a sweetness softened by smoke and time. Fruit darkened at the edges. Oak warmed by years of handling. Fabric carrying the memory of fire.",
      "The effect is intimate rather than grand — a scent of study, memory, and evenings that stretched longer than intended.",
      "It wears close, textured and contemplative, leaving behind the impression of warm wood, quiet indulgence, and secrets carefully kept.",
    ],
    storyClose: "A fragrance for the rooms where silence has been carefully kept.",
    size: "30 mL black glass bottle, presented in a black box.",
    ingredients:
      "Alcohol (cane sugar), parfum* (aromatic compounds from essential oils, CO₂ extracts, absolutes and purified plant isolates), aqua / water, Illicium verum fruit oil (Star Anise), Iris germanica root extract (Orris Root), triethyl citrate (natural ester of citric acid).",
    allergens:
      "*May contain naturally occurring fragrance allergens: limonene, linalool, geraniol, citronellol, benzyl alcohol, benzyl benzoate, coumarin.",
    attributes:
      "No phthalates • No parabens • No synthetic dyes • No formaldehyde.",
    sku: "HA-ARCHIVIST-30ML",
    noteSlugs: [
      "black-tea-the-steeped-hour",
      "oakwood-the-slow-cask",
      "amber-the-fossil-glow",
      "labdanum-the-golden-shadow",
      "tonka-bean-the-soft-coumarin",
      "vanilla-the-quiet-hearth",
    ],
  },
  {
    slug: "the-still",
    name: "The Still",
    subtitle: "A Misted Green Study",
    price: "From $11.00 USD",
    installment: "Also available in sample sizes",
    image: productStill,
    imageAlt: "The Still — misted fern and pale forest atmosphere artwork for House of Apocrypha",
    gallery: [
      {
        src: bottleStillCap,
        alt: "The Still bottle with black cap in a cool misted stone scene",
        caption: "Bottle portrait · cap on",
      },
      {
        src: bottleStillSpray,
        alt: "The Still bottle with silver atomizer exposed, cool mist drifting in pale green light",
        caption: "Bottle study · silver atomizer in use",
      },
    ],
    searchAnchor:
      "The Still is a small-batch natural perfume — fern mist, juniper, rosemary, mastic resin and pale woods, available in sample sizes from House of Apocrypha.",
    storyTagline: "Cool vapor, green hush, and light through glass.",
    noteLine: "Fern mist · pale woods · cool air",
    format: "30ml extrait · sample sizes available",
    batch: "Batch I · limited release",
    accents: ["Fern", "Wet greens", "Pale woods", "Mist", "Herbal vapor"],
    storyParagraphs: [
      "The Still is the quietest room in the house: condensation on glass, herbs hung to dry, and a soft mineral coolness settling over everything before dawn. It opens in a vapor of green notes — airy, clean, and gently herbal.",
      "As it develops, the fragrance becomes more diffused and atmospheric. Fern-like freshness, pale wood, and a watery translucence create the sensation of walking through mist rather than wearing perfume.",
      "Its beauty lies in restraint — delicate, eerie, and almost luminous against the skin.",
      "Wear it, and the world lowers its voice.",
    ],
    storyClose: "Less a statement than a weather pattern, passing close to the body.",
    size: "Sample vials and limited formats as released.",
    ingredients:
      "Alcohol (cane sugar), parfum* (aromatic compounds from essential oils, CO₂ extracts, absolutes and purified plant isolates), aqua / water, triethyl citrate (natural ester of citric acid).",
    allergens:
      "*May contain naturally occurring fragrance allergens: limonene, linalool, geraniol, citronellol, citral.",
    attributes:
      "Vegetarian • No phthalates • No parabens • No synthetic dyes • No formaldehyde.",
    sku: "HA-STILL",
    noteSlugs: [
      "juniper-berry-the-cold-blue",
      "rosemary-the-cold-altar",
      "mastic-the-pale-resin",
      "ho-wood-the-pale-breath",
      "oakmoss-the-forest-floor",
    ],
  },
  {
    slug: "a-gentle-madness",
    name: "A Gentle Madness",
    subtitle: "A Strange Green Sweetness",
    price: "$135.00 USD",
    installment: "",
    image: productGentleMadness,
    imageAlt: "A Gentle Madness — green crystal goblet still-life artwork for House of Apocrypha",
    gallery: [
      {
        src: bottleGentleMadnessCap,
        alt: "A Gentle Madness bottle with black cap beside green crystal and sugar cube",
        caption: "Bottle portrait · cap on",
      },
      {
        src: bottleGentleMadnessSpray,
        alt: "A Gentle Madness bottle with silver atomizer exposed, green-lit mist and sugar cube nearby",
        caption: "Bottle study · silver atomizer in use",
      },
    ],
    searchAnchor:
      "A Gentle Madness is a small-batch natural perfume with green sweetness, sweet fennel, marshmallow and tonka — a 30 mL extrait by House of Apocrypha.",
    storyTagline: "Sugar held to the light until it turns strangely familiar, yet mysteriously unsettling.",
    noteLine: "Green crystal · sugar cube · black stone",
    format: "30ml extrait · $135",
    batch: "Batch I · limited release",
    accents: ["Green sweetness", "Crystal facets", "Sugar", "Mineral coolness", "Soft shadow"],
    storyParagraphs: [
      "A Gentle Madness begins with brightness, but not the expected kind. It feels green and faceted — like light split through crystal, or sweetness glimpsed through glass rather than tasted outright.",
      "There is sugar here, though it arrives with restraint: dry, mineral, and strangely familiar in a way that makes the room feel slightly wrong. The composition balances translucence and shadow, holding something almost edible against a darker ground of stillness and stone.",
      "The result is both graceful and strange — luminous, controlled, and just slightly askew.",
    ],
    storyClose: "A perfume that smiles without ever quite explaining why.",
    size: "30 mL black glass bottle, presented in a black box.",
    ingredients:
      "Alcohol (cane sugar), parfum* (aromatic compounds from essential oils, CO₂ extracts, absolutes and purified plant isolates), aqua / water, triethyl citrate (natural ester of citric acid).",
    allergens:
      "*May contain naturally occurring fragrance allergens: limonene, linalool, geraniol, citronellol, coumarin, benzyl alcohol.",
    attributes:
      "Vegetarian • No phthalates • No parabens • No synthetic dyes • No formaldehyde.",
    sku: "HA-GENTLE-30ML",
    noteSlugs: [
      "sweet-fennel-the-licorice-light",
      "marshmallow-the-soft-trick",
      "tonka-bean-the-soft-coumarin",
    ],
  },
];

export function getProduct(slug: string) {
  return products.find((p) => p.slug === slug);
}

export function getProductsForCharacter(characterSlug: string) {
  return products.filter((p) => p.noteSlugs.includes(characterSlug));
}
